import React, { Component } from 'react'
import { track as trackError, trackSlothOfDeath } from 'lib/utils/errors'
import { trackTimeTillInteractive } from 'lib/utils/stats'
import ErrorPage from 'components/ErrorPage'
import Routes from '../routes'

// Root handles initializing the app.
class Root extends Component {
  state = {
    isErrored: false
  }

  render() {
    if (this.state.isErrored) {
      return React.createElement(ErrorPage)
    }

    return React.createElement(Routes)
  }

  componentDidMount() {
    trackTimeTillInteractive('spa')
  }

  componentDidCatch(err) {
    trackError(err)
    trackSlothOfDeath(err)
    this.setState({ isErrored: true })
  }
}

export default Root
